import React, { useState, useContext, useEffect } from "react";
import { authContext } from '../provider/Auth'
import { withRouter } from 'react-router-dom';

const AuthSwitch = withRouter(({children, history, redirectTo}) => {
  const { state: {loggedIn, isDeserializing, error} } = useContext(authContext);
    useEffect(() => {
      if (!isDeserializing && !loggedIn && redirectTo) {
        if (history.location.pathname !== redirectTo) {
          history.push(redirectTo)
        }
      }
    })
  if (!loggedIn) return null
  return <>
    {children}
  </>
})

export default AuthSwitch;